import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pedestrian: null,
  auto: null,
  transit: null,
  bicycle: null,
  freight: null
}

const weakestLinkVariables = createSlice({
  name: 'weakestLinkVariables',
  initialState,
  reducers: {
    setWeakestLinkVariables(state, action) {
      const { field, value } = action.payload
      state[field] = value
    }
  }
})

export const { setWeakestLinkVariables } = weakestLinkVariables.actions
export default weakestLinkVariables.reducer
